import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./Dodavatel.scss";

// prop types
import dodavatelPropTypes from "../../propTypes/dodavatelPropTypes";
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as dodavatelActions from "../../actions/dodavatel/dodavatelActions";

// components
import ErrorMsg from "../ErrorMsg";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";

const SCHEMA = [
  { field: "NAZOV", title: "Názov" },
  { field: "ADRESA_SIDLO", title: "Adresa" },
  { field: "ICO_DIC", title: "IČO/DIČ" },
  { field: "TELEFON", title: "Telefón" },
  { field: "MAIL", title: "E-mail" },
  { field: "MAIL_FAKT", title: "E-mail faktúry" },
  { field: "WEB", title: "Web stránka" },
  { field: "OBCH_REG", title: "Obch. register" },
];

class Dodavatel extends React.Component {
  // METHODS
  renderDataForWeb = () => {
    return SCHEMA.map((obj, key) => {
      const { field, title } = obj;

      return (
        <React.Fragment key={key}>
          <div className="col-3 pl-3 title">
            <p>{title}: </p>
          </div>
          <div className="col-9 pl-3">
            <p>{this.props.dodavatel[field]}</p>
          </div>
        </React.Fragment>
      );
    });
  };
  renderDataForMobile = () => {
    return SCHEMA.map((obj, key) => {
      const { field, title } = obj;

      return (
        <React.Fragment key={key}>
          <div className="col-4 p-0 title">
            <p>{title}: </p>
          </div>
          <div className="col-8 p-0">
            <p>{this.props.dodavatel[field]}</p>
          </div>
        </React.Fragment>
      );
    });
  };

  // SYSTEM METHODS
  componentDidMount = async () => {
    const {
      changeHeaderTitle,
      showAppHeader,
      getDodavatel,
      odberatel,
      update,
    } = this.props;

    showAppHeader(false);
    changeHeaderTitle("Dodávateľ");

    if (update) await getDodavatel(odberatel.I_DODAVATEL);
  };
  render() {
    const { dodavatel, isOdberatelPicked, isLoading } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <div className="webDodavatel">
            <div className="row m-0">
              {isOdberatelPicked && dodavatel && this.renderDataForWeb()}
            </div>
          </div>

          <div className="mobileDodavatel">
            <div className="row m-0">
              {isOdberatelPicked && dodavatel && this.renderDataForMobile()}
            </div>
          </div>

          {!isOdberatelPicked && <ErrorMsg text="Vyberte odberateľa" />}
          <LoadingPanel isLoading={isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // DODAVATEL
    dodavatel: state.dodavatel.data,
    isLoading: state.dodavatel.isLoading,
    update: state.dodavatel.update,

    // ODBERATEL
    isOdberatelPicked: state.odberatel.isPicked,
    odberatel: state.odberatel.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDodavatel: async (I_DODAVATEL) =>
    await dispatch(dodavatelActions.getDodavatel(I_DODAVATEL)),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Dodavatel.propTypes = {
  changeHeaderTitle: PropTypes.func,
  dodavatel: dodavatelPropTypes.dodavatel,
  getDodavatel: PropTypes.func,
  isLoading: PropTypes.bool,
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
  update: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dodavatel);
